import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  Typography,
} from '@material-ui/core';
import Button from 'components/Button';
import i18n from 'i18n';
import React from 'react';
import { modalStyles } from './styles';

type ConfirmDisableDeviceDialogProps = {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

const ConfirmDisableDeviceDialog = ({
  open,
  onConfirm,
  onClose,
}: ConfirmDisableDeviceDialogProps) => {
  const useStyles = makeStyles(modalStyles());
  const classes = useStyles({});

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      aria-labelledby="confirm-dialog-title"
    >
      <DialogTitle id="confirm-dialog-title" className={classes.title}>
        <Typography variant="h6" className={classes.titleText}>
          {i18n.t('CONFIRM_DELETE_TRUSTED_DEVICE_KEY')}
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Typography className={classes.contentText}>
          {i18n.t('CONFIRM_DELETE_TRUSTED_DEVICE_MESSAGE_KEY')}
        </Typography>
      </DialogContent>
      <DialogActions className={classes.buttonsContainer}>
        <Button onClick={onClose} variant="outlined">
          {i18n.t('CANCEL_KEY')}
        </Button>
        <Button onClick={onConfirm} submitButton>
          {i18n.t('CONFIRM_KEY')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDisableDeviceDialog;
